import { createReducer } from "@reduxjs/toolkit";
import { deleteBatch, resetDeleteBatch } from "./delete-batch";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const deleteBatchReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(deleteBatch.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(deleteBatch.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(deleteBatch.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetDeleteBatch, () => {
    return initialState;
  });
});
